<template>
	<v-container class="pa-1">

    <v-snackbar v-model="alerta.activo" multi-line :vertical="true" top right :color="alerta.color" > 
      <strong> {{alerta.texto}} </strong>
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text @click="alerta.activo = false" v-bind="attrs"> Cerrar </v-btn>
      </template>
    </v-snackbar>

    <v-toolbar flat class="">
      <div class="font-weight-black text-md-h6 text-xs-subtitle-1 "> DETALLE DEL PEDIDO  </div>
      <v-spacer></v-spacer>
      <v-btn color="error" fab small elevation="1" @click="$emit('modal',false)" ><v-icon>clear</v-icon></v-btn>
    </v-toolbar>

    <v-container style="height: 300px;" v-if="Loading">
      <loading/>
    </v-container>

		<v-row v-if="!Loading">

      <v-col cols="12" class="mt-1">
        <v-card outlined class="">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="font-weight-black subtitle-1">Dirección de envío</v-list-item-title>
              <v-divider></v-divider>
            </v-list-item-content>
          </v-list-item>

          <v-row class="pa-4">
            <v-col cols="12" sm="5" class="py-0">
              <v-list-item-subtitle >
                <span class="font-weight-black caption"> Nombre: </span>
                <span class="caption"> {{ envio.nombre }} {{ envio.apellido }} </span> 
              </v-list-item-subtitle>
              <v-list-item-subtitle >
                <span class="font-weight-black caption"> Municipio: </span>
                <span class="caption"> {{ envio.municipio }} </span> 
              </v-list-item-subtitle>
              <v-list-item-subtitle >
                <span class="font-weight-black caption"> Colonia: </span>
                <span class="caption"> {{ envio.colonia }} </span> 
              </v-list-item-subtitle>
            </v-col>

            <v-col cols="12" sm="7" class="py-0">
              <v-list-item-subtitle >
                <span class="font-weight-black caption"> Calle: </span>
                <span class="caption"> {{ envio.calle }}, #{{ envio.numero }}, CP: {{ envio.cp }} </span> 
              </v-list-item-subtitle>
              <v-list-item-subtitle >
                <span class="font-weight-black caption"> Teléfono: </span>
                <span class="caption"> {{ envio.telefono }} </span> 
              </v-list-item-subtitle>
              <v-list-item-subtitle >
                <span class="font-weight-black caption"> Correo electrónico: </span>
                <span class="caption"> {{ envio.email }} </span> 
              </v-list-item-subtitle>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <!-- DIRECCION ENVIO -->
      <!-- <v-col cols="12"  class=" mt-1">
        <v-card  outlined>
           <v-list-item >
            <v-list-item-content >
              <v-list-item-title class="font-weight-black subtitle-1"> Dirección de envío</v-list-item-title>
              <v-divider></v-divider>
              <v-list-item-subtitle>
               <span class="font-weight-black caption" v-if="$vuetify.breakpoint.name != 'xs'">  Nombre:  </span> 
               <span class="caption"> {{ envio.nombre }} {{ envio.apellido }}  </span>
              </v-list-item-subtitle>
              <v-list-item-subtitle>
               <span class="font-weight-black caption" v-if="$vuetify.breakpoint.name != 'xs'">  Municipio: </span>  
               <span class="caption"> {{ envio.municipio }}  </span>
              </v-list-item-subtitle>
              <v-list-item-subtitle>
               <span class="font-weight-black caption" v-if="$vuetify.breakpoint.name != 'xs'">  Colonia:  </span>  
               <span class="caption"> {{ envio.colonia }} </span>
              </v-list-item-subtitle>
              <v-list-item-subtitle>
               <span class="font-weight-black caption" v-if="$vuetify.breakpoint.name != 'xs'">  Calle: </span>  
               <span class="caption"> {{ envio.calle }} {{ envio.numero }}, {{ envio.cp }} </span>
              </v-list-item-subtitle>
              <v-list-item-subtitle>
               <span class="font-weight-black caption" v-if="$vuetify.breakpoint.name != 'xs'">  Telefono: </span>  
               <span class="caption"> {{ envio.telefono }}  </span>
              </v-list-item-subtitle>
              <v-list-item-subtitle>
               <span class="font-weight-black caption" v-if="$vuetify.breakpoint.name != 'xs'">  Correo electronico: </span> 
               <span class="caption"> {{ envio.email}}  </span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card> 
      </v-col> -->
      
      <!-- DIRECCION FACTURACIÓN -->
      <!-- <v-col cols="12" sm="6"  class="mt-1" v-if="facturacion">
        <v-card outlined >
           <v-list-item link>
            <v-list-item-content >
              <v-list-item-title class="font-weight-black subtitle-1"> Dirección de facturación</v-list-item-title>
              <v-divider></v-divider>
              <v-list-item-subtitle>
               <span class="font-weight-black caption" v-if="$vuetify.breakpoint.name != 'xs'">  Nombre:  </span> 
               <span class="caption"> {{facturacion.nombre }} {{facturacion.apellido }}  </span>
              </v-list-item-subtitle>
              <v-list-item-subtitle>
               <span class="font-weight-black caption" v-if="$vuetify.breakpoint.name != 'xs'">  Municipio: </span>  
               <span class="caption"> {{facturacion.municipio }}  </span>
              </v-list-item-subtitle>
              <v-list-item-subtitle>
               <span class="font-weight-black caption" v-if="$vuetify.breakpoint.name != 'xs'">  Colonia:  </span>  
               <span class="caption"> {{facturacion.colonia }} </span>
              </v-list-item-subtitle>
              <v-list-item-subtitle>
               <span class="font-weight-black caption" v-if="$vuetify.breakpoint.name != 'xs'">  Calle: </span>  
               <span class="caption"> {{ envio.calle }} {{ envio.numero }}, {{ envio.cp }} </span>
              </v-list-item-subtitle>
              
              <v-list-item-subtitle>
               <span class="font-weight-black caption" v-if="$vuetify.breakpoint.name != 'xs'">  Telefono: </span>  
               <span class="caption"> {{facturacion.telefono }}  </span>
              </v-list-item-subtitle>
              <v-list-item-subtitle>
               <span class="font-weight-black caption" v-if="$vuetify.breakpoint.name != 'xs'">  Correo electronico: </span> 
               <span class="caption"> {{facturacion.email}}  </span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card> 
      </v-col>
       -->

      <!-- PRODUCTOS DE LA LISTA -->
			<v-col cols="12" class="py-0" elevation="0">
        <v-card  v-for="(item, i) in productos" :key="i"  outlined class="mt-1 ">
           <v-list-item class="py-0">
            <v-list-item-avatar :size="$vuetify.breakpoint.name === 'xs'? 40:110" tile>
              <v-img :src="url + item.foto" v-if="item.foto" loading="lazy"></v-img>
              <v-img :src="`${url + photo}`" loading="lazy" v-else/>
            </v-list-item-avatar>
            
            <v-list-item-content >
              <v-list-item-subtitle class="pb-0 text-caption">
               <span class="font-weight-black"  >  Codigo: </span> {{ item.codigo }}  
              </v-list-item-subtitle>
              <v-list-item-subtitle class="text-caption">
               <span class="font-weight-black "  >  Producto : </span>  {{ item.nomart}}
              </v-list-item-subtitle>
              <v-list-item-subtitle class="text-caption">
                <span class="font-weight-black"  >  Cantidad:  </span> {{ item.cantidad }} 
              </v-list-item-subtitle>
              <v-list-item-subtitle class="text-caption">
                <span class="font-weight-black "  > Precio:  </span>  
                {{ item.precio1 - (item.pjedesc / 100) * item.precio1  | currency(2) }} MX.
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card> 
      </v-col>

       <!-- CREAR GUIA DE PEDIDO target="_blank"  :href="parametros.rastreo[0].trackUrl" -->
      <!-- <v-col cols="12" sm="5" md="6" class="">
        <v-btn block outlined color="secondary" @click="alerta_generar_guia = true" > 
          Crear guía del pedido. <v-icon class="text-decoration-underline mx-3" right large> mdi-truck-fast-outline </v-icon>
        </v-btn>
      </v-col> -->

      <!-- TOTAL DEL CARRITO -->
      <v-col cols="12" sm="6" class="py-0" offset-sm="6">
        <v-card outlined class=" mt-2">
          <v-list dense >
            <v-list-item link class="py-0">
              <v-list-item-content>
                <v-list-item-title > Subtotal</v-list-item-title>
              </v-list-item-content>
              <v-list-item-content class="text-right">
                <v-list-item-title > {{ parametros.subtotal | currency(2) }} </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link class="py-0">
              <v-list-item-content>
                <v-list-item-title > Envío </v-list-item-title>
              </v-list-item-content>
              <v-list-item-content class="text-right" >
                <v-list-item-title v-if="parametros.envio_gratis"> 
                  <v-btn text small color="success" class="font-weight-black"> Envío Gratis </v-btn>
                </v-list-item-title>
                <v-list-item-title v-else> 
                  {{ parametros.envio | currency(2) }} 
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link class="py-0" v-if="parametros.descuento_cupon != 0">
              <v-list-item-content>
                <v-list-item-title > Cupon promocional </v-list-item-title>
              </v-list-item-content>
              <v-list-item-content class="text-right">
                <v-list-item-title > {{ parametros.descuento_cupon | currency(2) }} </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

              <v-list-item link class="py-0">
              <v-list-item-content>
                <v-list-item-title > Total </v-list-item-title>
              </v-list-item-content>
              <v-list-item-content class="text-right">
                <v-list-item-title > {{ parametros.total | currency(2) }} </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>

      <!-- <v-dialog v-model="alerta_generar_guia"  persistent width="400">
        <v-card>
          <v-card-title class="subtitle-1 font-weight-black " style="word-break:normal;">¿ESTÁS SEGURO DE QUERER GENERAR LA GUÍA DEL PEDIDO ? </v-card-title>
          <v-divider class="my-0 py-3" ></v-divider>
          <v-card-subtitle align="center" class="red--text font-weight-bold "> LA GESTIÓN POSTERIOR SE LLEVARA EN ENVIA.COM </v-card-subtitle>
          <v-divider class="my-0 py-2 " ></v-divider>
          <v-card-actions>
            <v-btn color="gris"    dark   @click="alerta_generar_guia = false" >  NO, CANCELAR </v-btn>
            <v-spacer/>
            <v-btn color="celeste" text   @click="generar_guia_pedido()" >  SÍ, GENERAR </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->

		  <overlay v-if="overlay"/>


    </v-row>
  </v-container>
</template>

<script>
  import  metodos from '@/mixins/metodos.js';
	import {mapGetters, mapActions} from 'vuex'
  import loading from '@/components/loading.vue'
  import overlay from '@/components/overlay.vue'
	var accounting = require("accounting");

  export default {
    mixins:[metodos],
	  components: {
			loading,
      overlay
		},
		props:[
			'parametros',
	  ],

    data(){
      return{
        productos:[],
        envio:[],
        facturacion:[],
        
        Loading: false,
        url   : this.$http.options.root + 'fotos-epic-grass/' ,
        photo : 'nophoto.png',
        ObjectDefault:{},
        alerta: { activo: false, texto:'', color:'error' },

        alerta_generar_guia: false,
        overlay: false
      }
    },

    created(){
				this.initialize();
		},

    watch:{
			parametros(){
				this.initialize();
			},
    },
			
		computed:{
			// IMPORTANDO USO DE VUEX - CLIENTES (GETTERS)
      ...mapGetters('Login',['getusuarioFetish']),
		},

    filters:{
      currency(val, dec){
        return accounting.formatMoney(val, '$', dec)
      }
    },
    
    methods:{

      initialize(){

        this.Loading = true;
        this.envio       = this.parametros.direcciones[0];
        // this.facturacion = this.parametros.facturacion[0];
        this.productos   = this.parametros.movim;
        setTimeout(()=> {this.Loading = false }, 500); 
        
        // //  CONSULTAR DIRECCION 
        // this.$http.get('obtener.direccion.envio.docum/' + this.parametros.iddirecion).then( response =>{
        //   this.envio = response.body[0];
        // });
        // //  CONSULTAR FACTURACION
        // this.$http.get('obtener.direccion.facturacion.docum/' + this.parametros.iddireccionfacturacion).then( response =>{
        //   this.facturacion = response.body[0];
        // });
        // //  CONSULTAR PRODUCUCTOS SOLICITADOS
        // this.$http.get('obtener.productos.movim/' + this.parametros.iddocum).then( response =>{
        //   this.productos =  response.body;
        // }).finally(()=>{
        //   this.Loading = false;
        // })
      },

      /*generar_guia_pedido(){
        this.alerta_generar_guia = false; this.overlay = true; 
        this.generarEnvio(this.parametros.idpago,this.envio, this.productos).then(response =>{
          this.alerta = { activo: true, 
                          texto: response.mensaje, 
                          color:'success' 
                        };
        }).catch( error =>{
          console.log(error);
          this.alerta = { activo: true,
                          texto: error.mensaje, 
                          color:'error' 
                        };
        }).finally(() => { this.overlay = false; })
      }*/
    } 



  }
</script>